const getState = ({ getStore, getActions, setStore }) => {
    return {
        store: {
  
        },




        actions: {

        
        }
    }
}
export default getState;